import { api } from "../Configurations/axios";
import { toast } from "react-toastify";


const GetPleaImpactbyPleaId = async (pleaId: string) => {
  try {
    const result = await api.get(`/PleaImpacts/GetPleaImpactsByPleaId?pleaId=${pleaId}`);
    const response = await result.data;
    return response;
  } catch (error: any) {
    throw new Error(error.response.data);
  }
}

const GetPleaImpactFilesById = async (pleaId: string) => {
  try {
    const result = await api.get(`/PleaImpacts/GetPleaImpactFilesByPleaId?pleaId=${pleaId}`);
    const response = await result.data;
    return response;
  } catch (error: any) {
    throw new Error(error.response.data);
  }
}


const PleaImpactChangedSelect = async (idField: string, value: number, pleaId: string, companyId: string, userEmail: string) => {
  try {
    const result = await api.post('/PleaImpacts/ChangeSelect', {
      IdField: idField,
      Value: value,
      PleaId: pleaId,
      CompanyId: companyId,
      UserEmail: userEmail
    });
    const response = await result.data;
    return response;
  } catch (error: any) {
    throw new Error(error.response.data);
  }


}
const UploadPleaImpact = async (files: File[], url: string, userEmail: string, pleaId: string) => {
  try {
    var UploadFilePleaImpact = new FormData();
    files.forEach(file => {
      UploadFilePleaImpact.append("files", file);
    });

    const result = await api.post(`/PleaImpacts/PostFilePleaImpacts?Url=${url}&userEmail=${encodeURIComponent(userEmail)}&pleaId=${pleaId}`, UploadFilePleaImpact, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    const response = await result.data;
    return response;
  } catch (error: any) {
    toast.error(error);
    throw new Error(error.response.data);
  }
}

const  DownloadPleaImpactsFile = async(Id: String ) =>{
      try{
          const result = await api.get(
            `/PleaImpacts/DownloadPleaImpactsFile?id=${Id}`,{
              responseType: 'blob'
          });
          const response = result.data;
          return response;
      }catch(error: any) {
          throw new Error(error.response.data);
      }
};
const DeletePleaImpactsFile = async ( companyId: string ,fileName: string, id: string, pleaId: string) => {
    try {
        const data = {companyId, id: id, fileName: fileName, pleaId: pleaId };
        const result = await api.delete("/PleaImpacts/DeletePleaImpactsFile", { data });
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

export {
  GetPleaImpactbyPleaId,
  PleaImpactChangedSelect,
  UploadPleaImpact,
  GetPleaImpactFilesById,
  DownloadPleaImpactsFile,
  DeletePleaImpactsFile
}


